import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
// import { CustomIcon } from '../../../../../apps/AppComponents/IconPicker/IconPicker'
import {
  setActiveLotId,
  setDestination,
  setDirectionRoutes,
  setMarkerInfo,
  updateBottomSheet,
} from '../../redux/myMapsSlice'
import { isWithinRadius } from '../../helpers/helpers'
import lotLabelStyles from './lotLabelStyles'
import { setPolylineStyle } from '../../../../utils/helpers'
import {
  MOBILEPARKINGINFOWINDOW,
  PARKINGOVERLAY,
} from '../../../../utils/constants'
import { logMapEvent } from '../../../../utils/events'

const LotLabelMarker = ({
  parkingLotData,
  activeLotId,
  filterBy,
  additionalFilters,
  userParkingPermitData,
  latitude,
  longitude,
  dispatch,
  isMobile,
  zoom,
}) => {
  const [markers, updateMarkers] = React.useState([])
  React.useEffect(() => {
    let finalFilteredParkingObjs
    const filteredLabelObjs = parkingLotData.filter((parkingLot) => {
      if (parkingLot?.active !== true) {
        return false
      }
      if (filterBy.length === 0 || parkingLot?.mapId === activeLotId) {
        return true
      }
      return filterBy.some((filter) => {
        if (filter === 'Faculty/Staff') return parkingLot?.employee === true
        if (filter === 'student') return parkingLot?.student === true
        if (filter === 'permit') {
          return userParkingPermitData?.garageIdInfo?.some(
            (permitLot) => permitLot.garageId === parkingLot?.baseId,
          )
        }
        return false
      })
    })
    finalFilteredParkingObjs = filteredLabelObjs
    // filter by additional options if applied by user
    if (additionalFilters?.length > 0) {
      finalFilteredParkingObjs = filteredLabelObjs.filter((parkingLot) =>
        additionalFilters.every((filter) => {
          if (filter === 'visitor') return parkingLot?.visitor > 0
          if (filter === 'handicapped') return parkingLot?.handicapped > 0
          if (filter === 'evCharging') return parkingLot?.evCharging !== 0
          if (filter === 'covered')
            return parkingLot?.solar === true || parkingLot?.garage === true
          if (filter === 'gated') return parkingLot?.regularGate === true
          if (filter === 'permit') {
            return userParkingPermitData?.garageIdInfo?.some(
              (permitLot) => permitLot.garageId === parkingLot?.baseId,
            )
          }
          return false
        }),
      )
    }
    const nearestParking = isWithinRadius(
      latitude,
      longitude,
      finalFilteredParkingObjs,
    )
    updateMarkers(nearestParking)
  }, [latitude, longitude, zoom, filterBy, additionalFilters, activeLotId])
  return (
    <div>
      {markers?.map((marker) => (
        <LotLabelAdvancedMarker
          key={marker?.mapId}
          marker={marker}
          dispatch={dispatch}
          isMobile={isMobile}
          additionalFilters={additionalFilters}
        />
      ))}
    </div>
  )
}

const LotLabelAdvancedMarker = ({
  marker,
  dispatch,
  isMobile,
  additionalFilters,
}) => {
  const classes = lotLabelStyles()
  const [setActive, updateSetActive] = React.useState(false)
  const { markerInfo, parkingLotData, datasetLayer, filters } = useSelector(
    (s) => s.maps,
  )
  const handleUpdateShowCard = () => {
    dispatch(setMarkerInfo(marker))
    dispatch(setActiveLotId(marker?.mapId))
    dispatch(
      setDestination(
        `${marker?.address?.address1}, ${marker?.address?.cityCode}`,
      ),
    )
    dispatch(setDirectionRoutes([]))
    if (isMobile) {
      dispatch(updateBottomSheet(MOBILEPARKINGINFOWINDOW))
    }
    if (markerInfo && markerInfo?.mapId !== marker.mapId) {
      datasetLayer.style = ({ feature }) =>
        setPolylineStyle({
          feature,
          parkingLotData,
          filterBy: filters,
          additionalFilters,
          activeLotId: marker?.mapId,
        })
    }
    logMapEvent(dispatch, PARKINGOVERLAY, marker.propertyName)
  }
  React.useEffect(() => {
    if (markerInfo && markerInfo?.mapId === marker.mapId) {
      updateSetActive(!setActive)
    } else {
      updateSetActive(false)
    }
  }, [markerInfo])
  return (
    <AdvancedMarker
      position={{
        lat: marker?.location.lat,
        lng: marker?.location.lng,
      }}
      title={marker?.shortName}
      clickable
      onClick={handleUpdateShowCard}
      anchorPoint={AdvancedMarkerAnchorPoint.TOP}
      style={{ zIndex: 9999 }}
    >
      <div className={classes.lotLabelContainer}>
        <div>
          <Typography
            variant="subtitle1"
            style={{
              textShadow: `
                    -1px -1px 0 white,
                    1px -1px 0 white,
                    -1px 1px 0 white,
                    1px 1px 0 white`,
              color: 'black',
              fontSize: 14,
            }}
          >
            {marker.shortName}
          </Typography>
        </div>
      </div>
    </AdvancedMarker>
  )
}

export default LotLabelMarker
